import { createApp } from 'vue';
import App from '@/App.vue';
import { router } from '@/router';
import { pinia } from '@/store';
import { vuetify } from '@/plugins/vuetify';
import { initializeLiff } from '@/utils/liff';
import { isWebAccess } from '@/utils/accessMode';
import '@mdi/font/css/materialdesignicons.css';

// LIFF経由のアクセスならルーター解決前に初期化（パス復元のため早期実行が必要）。
// liff.state クエリは LIFF エンドポイントへのリダイレクト時に必ず付与されるため、
// ホスト名が WEB と同じドメイン（例: stg.10flow.ai）であっても LIFF として扱う必要がある。
// ※WEB経由で /patient/* にアクセスした際に LIFF／ダミーLINEが誤発火して
//   「山田太郎」画面になる事故を防ぐためのガードは liff.state 無し時のみ適用。
const hasLiffState = window.location.search.includes('liff.state');
const isLiffAccess =
  hasLiffState ||
  (!isWebAccess() &&
    (window.location.pathname.startsWith('/patient') ||
      document.referrer.includes('line.me')));

const liffReady = isLiffAccess ? initializeLiff().catch(() => {}) : Promise.resolve();

liffReady.then(() => {
  const app = createApp(App);

  app.use(pinia);
  app.use(router);
  app.use(vuetify);

  app.config.errorHandler = (err, _instance, info) => {
    console.error('[Global Error]', err, info);
  };

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Unhandled Rejection]', event.reason);
  });

  app.mount('#app');
});
